import React, { useState } from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const MenuItemCard = ({ item, onOrderClick, onFavoriteToggle }) => {
  const [isFavorite, setIsFavorite] = useState(item?.isFavorite || false);

  const handleFavoriteClick = () => {
    setIsFavorite(!isFavorite);
    onFavoriteToggle(item?.id, !isFavorite);
  };

  const handleWhatsAppOrder = () => {
    const message = `Hello Chapati Plus! I would like to order:\n\n${item?.name}\nPrice: ${item?.price} SSP\n\nPlease confirm availability.`;
    window.open(`https://wa.me/211911027181?text=${encodeURIComponent(message)}`, '_blank');
  };

  return (
    <div className="bg-card rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 group">
      <div className="relative aspect-[4/3] overflow-hidden">
        <Image
          src={item?.image}
          alt={item?.imageAlt}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
        />
        
        <button
          onClick={handleFavoriteClick}
          className="absolute top-3 right-3 w-10 h-10 bg-background/90 backdrop-blur-sm rounded-full flex items-center justify-center hover:scale-110 transition-transform duration-300 shadow-lg"
          aria-label={isFavorite ? 'Remove from favorites' : 'Add to favorites'}>

          <Icon
            name={isFavorite ? 'Heart' : 'Heart'}
            size={20}
            color={isFavorite ? 'var(--color-primary)' : 'var(--color-muted-foreground)'}
            className={isFavorite ? 'fill-current' : ''} />

        </button>

        {item?.isPopular &&
        <div className="absolute top-3 left-3 bg-secondary text-secondary-foreground px-3 py-1 rounded-full text-xs font-bold flex items-center gap-1 shadow-lg">
            <Icon name="TrendingUp" size={14} />
            <span>Popular</span>
          </div>
        }

        {item?.isNew &&
        <div className="absolute top-3 left-3 bg-accent text-accent-foreground px-3 py-1 rounded-full text-xs font-bold flex items-center gap-1 shadow-lg">
            <Icon name="Sparkles" size={14} />
            <span>New</span>
          </div>
        }

        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-3">
          <div className="flex items-center gap-2 text-white text-xs">
            <Icon name="Clock" size={14} />
            <span>{item?.prepTime} mins</span>
          </div>
        </div>
      </div>
      <div className="p-4 md:p-5 space-y-3">
        <div className="space-y-2">
          <h3 className="text-lg md:text-xl font-bold text-foreground line-clamp-1">
            {item?.name}
          </h3>
          <p className="text-sm md:text-base text-muted-foreground line-clamp-2">
            {item?.description}
          </p>
        </div>

        <div className="flex flex-wrap gap-2">
          {item?.dietary?.map((diet, index) =>
          <span
            key={index}
            className="inline-flex items-center gap-1 px-2 py-1 bg-muted rounded-full text-xs text-muted-foreground">

              <Icon name={diet?.icon} size={12} />
              <span>{diet?.label}</span>
            </span>
          )}
        </div>

        {item?.ingredients &&
        <div className="pt-2 border-t border-border">
            <p className="text-xs text-muted-foreground">
              <span className="font-semibold">Ingredients:</span> {item?.ingredients}
            </p>
          </div>
        }

        {item?.nutrition &&
        <div className="flex items-center gap-3 text-xs text-muted-foreground">
            <span className="flex items-center gap-1">
              <Icon name="Flame" size={12} />
              {item?.nutrition?.calories} cal
            </span>
            <span>•</span>
            <span>{item?.nutrition?.protein}g protein</span>
          </div>
        }

        <div className="flex items-center justify-between pt-3 border-t border-border">
          <div className="space-y-1">
            <p className="text-2xl md:text-3xl font-bold text-primary">
              {item?.price} <span className="text-base md:text-lg">SSP</span>
            </p>
            <p className="text-xs text-muted-foreground">
              Serves {item?.servingSize}
            </p>
          </div>

          <div className="flex gap-2">
            <Button
              variant="outline"
              size="default"
              iconName="Phone"
              onClick={() => window.open('tel:+211123456789', '_self')}
              className="hidden md:flex">

              Call
            </Button>
            <Button
              variant="default"
              size="default"
              iconName="MessageCircle"
              iconPosition="left"
              onClick={handleWhatsAppOrder}
              className="bg-accent hover:bg-accent/90">

              Order
            </Button>
          </div>
        </div>
      </div>
    </div>);

};

export default MenuItemCard;